import { z } from 'zod';
import { optionalNonNegativeIntString, optionalNonNegativeNumberString, optionalUuidString, } from '../zod-helpers/index.js';
import { PART_CONSTRAINTS } from './constraints.js';
export const partCostingEditFormSchema = z.object({
    stdCost: optionalNonNegativeNumberString(PART_CONSTRAINTS.stdCost.label),
    leadTime: optionalNonNegativeIntString(PART_CONSTRAINTS.leadTime.label),
    taxId: optionalUuidString('Invalid tax rate selection.'),
    inventoryAccountId: optionalUuidString('Invalid inventory account.'),
    cogsAccountId: optionalUuidString('Invalid COGS account.'),
    varianceAccountId: optionalUuidString('Invalid variance account.'),
    scrapAccountId: optionalUuidString('Invalid scrap account.'),
    adjustmentAccountId: optionalUuidString('Invalid adjustment account.'),
});
//# sourceMappingURL=costing-form.js.map